module.exports = __webpack_public_path__ + "static/img/3.2badcc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/shuzihua/3.jpg
// module id = 3nRl
// module chunks = 1 2